<template>
  <section class="h5public-personal h5--page">
    <!-- <pcTitle v-if="isPC" @dispatchUserName="receiveName" @seeName="seeName"></pcTitle> -->
    <div align="center" style="color: #409EFF;margin: 10px;">资料订阅</div>
    <div align="right">
      <el-input size="mini" v-model="content" style="width: calc(100% - 110px);" clearable placeholder="请输入关键词进行搜索"></el-input>
    </div>
    <div>
      <el-tabs v-model="activeName" tab-position="left" class="dingyue">
        <el-tab-pane label="五星订阅：" name="second">
          <div class="file-list-per" v-if="tableData5.length">
            <div class="line" v-for="(item, index) in tableData5" :key="'a' + index">
              <span class="left">{{item.name}}</span>
              <p class="right" @click="openIt(item)">查看</p>
            </div>
          </div>
          <!-- <div v-if="tableData5.length">
            <div v-for="(item, index) in tableData5" :key="'a' + index" style="display: inline-block;">
              <span style="color: red;width: 20%;">{{item.name}}</span>
              <span style="margin: 0 0 0 80px;" @click="openIt(item)">查看</span>
            </div>
          </div> -->
          <div v-else>暂无~</div>
          <div align="right">
            <el-pagination
              hide-on-single-page
              small
              background
              v-if="total5 > 10"
              @current-change="handleCurrentChange5"
              layout="prev, pager, next"
              :total="total5"
              :page-size="pageSize5"
              :current-page="currentPage5">
            </el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane label="精华订阅：" name="first">
          <div class="file-list-per" v-if="tableData.length">
            <div class="line" v-for="(item, index) in tableData" :key="'a' + index">
              <span class="left">{{item.name}}</span>
              <span class="right" @click="openIt(item)">查看</span>
            </div>
          </div>
          <div v-else>暂无~</div>
          <div align="right">
            <el-pagination
              hide-on-single-page
              small
              background
              v-if="total > 10"
              @current-change="handleCurrentChange"
              layout="prev, pager, next"
              :total="total"
              :page-size="pageSize"
              :current-page="currentPage">
            </el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane label="一般订阅：" name="third">
          <div class="file-list-per" v-if="tableDataO.length">
            <div class="line" v-for="(item, index) in tableDataO" :key="'a' + index">
              <span class="left">{{item.name}}</span>
              <span class="right" @click="openItO(item)">查看</span>
            </div>
          </div>
          <div v-else>暂无~</div>
          <div align="right">
            <el-pagination
              class="right"
              hide-on-single-page
              small
              background
              v-if="totalO > 10"
              @current-change="handleCurrentChangeO"
              layout="prev, pager, next"
              :total="totalO"
              :page-size="pageSizeO"
              :current-page="currentPageO">
            </el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <splitNewFiles></splitNewFiles>
    <pcTitleLogOnly ref="pTLO" @beMember1="beMember"></pcTitleLogOnly>
    <fileRank></fileRank>
    <accountCom :showLogin.sync="loginDialogShow" @dispatchUserName="receiveName"></accountCom>
    <nut-dialog
      :visible="showGetInfo"
      title="查看详情"
      :closeOnClickModal="false"
      :closeBtnr="true"
      :noFooter="true">
      <span v-for="(item, index) in readMessage.split('+/b+')" :key="index">
        {{item.split('+b+')[0]}}<b>{{item.split('+b+')[1]}}</b>
      </span>
      <div align="center">
        <el-button type="primary" @click="showGetInfo = false" style="width:100px;height:36px;">取消</el-button>
        <el-button type="primary" @click="doGoRead(itemElse)" style="width:100px;height:36px;">确定</el-button>
      </div>
    </nut-dialog>
    <nut-dialog
      @close="memberFlag = false"
      :closeOnClickModal="false"
      v-if="memberFlag"
      :visible="memberFlag"
      title="公示会员详情"
      :noFooter="false"
      :onOkBtn="onOkBtn"
      :onCancelBtn="onCancelBtn"
      cancelBtnTxt="关闭">
      <div align="center">
        <span style="font-size: 16px;">{{ memberInfo }}</span>
      </div>
    </nut-dialog>
    <nut-dialog
      @close="memberFlag1 = false"
      :closeOnClickModal="false"
      v-if="memberFlag1"
      :visible="memberFlag1"
      title="公示会员详情"
      :noFooter="false"
      :onOkBtn="onOkBtn1"
      :onCancelBtn="onCancelBtn1"
      cancelBtnTxt="关闭">
      <div align="center">
        <span style="font-size: 16px;">{{ memberInfo1 }}</span>
      </div>
    </nut-dialog>
  </section>
</template>

<script>
import accountCom from '@/components/account/index'
// import banner from '@/components/public/banner'
// import pcTitle from '@/components/pcTitle'
import splitNewFiles from '@/components/public/splitNewFiles'
import fileRank from '@/components/public/fileRank'
import api from '../../api/index'
import detect from '@/util/detect'
import PcTitleLogOnly from '../components/pcTitle_logOnly.vue'
export default {
  data () {
    return {
      content: '',
      area: '',
      name: '',
      nameNum: '',
      publicTitle: '',
      userName: '',
      classa: '',
      time: '',
      commentList: [],
      isLoading: false,
      pageEnd: false,
      focusFlag: false,
      commentValue: '',
      avator: '',
      loginDialogShow: false,
      loginFlag: Boolean(sessionStorage.getItem('qs_token')),
      isPC: detect.isPC,
      // s
      showModuleConfig: [],
      searchObjGather: {
        file: {
          pro: '',
          sort: '0',
          searchClass: [],
          searchAreaClass: [],
          classMenuData: [],
          classAreaMenuData: []
        }
      },
      componentName: 'file',
      searchQ: '',
      childSearchQ: {},
      flexStyle: '0 0 300px',
      // 订阅文件
      subscribeType: 1,
      userId: 1,
      isMessage: 1,
      activeName: 'second',
      tableLoading: true,
      tableData: [],
      total: 0,
      pageSize: 10,
      currentPage: 1,
      tableLoadingO: true,
      tableDataO: [],
      totalO: 0,
      pageSizeO: 10,
      currentPageO: 1,
      tableData5: [],
      total5: 0,
      pageSize5: 10,
      currentPage5: 1,
      tableLoading5: true,
      showGetInfo: false,
      itemElse: {},
      readMessage: '',
      memberFlag: false,
      memberInfo: '',
      memberFlag1: false,
      memberInfo1: ''
    }
  },
  created () {
    if (this.$route.query.token) {
      this.$router.replace('/h5public-detail?id=' + this.$route.query.id)
    }
  },
  mounted () {
    this.seeName()
  },
  activated () {
    api.getUserInfo({
    }).then(res => {
      this.userId = res.data.userId
      this.getList(1)
      this.getListO(1)
      this.getList5(1)
    })
    this.loginFlag = Boolean(sessionStorage.getItem('qs_token'))
  },
  methods: {
    beMember () {
      console.log(1)
      api.publicityDescription({
        phone: sessionStorage.getItem('qs_phone')
      }).then(res => {
        this.memberInfo = res.message
        this.memberFlag = true
      })
    },
    onOkBtn () {
      api.publicityMembers({
        phone: sessionStorage.getItem('qs_phone')
      }).then(res => {
        if (res.code === 200) {
          this.memberFlag = false
          this.memberInfo1 = res.message
          this.memberFlag1 = true
        } else if (res.code === 500) {
          this.memberFlag = false
          this.memberInfo1 = res.message
          this.memberFlag1 = true
        }
      })
    },
    onCancelBtn () {
      this.memberFlag = false
    },
    onOkBtn1 () {
      this.memberFlag1 = false
    },
    onCancelBtn1 () {
      this.memberFlag1 = false
    },
    seeName (name) {
      this.nameNum = name
    },
    receiveName () {
      this.handleCommonItemClick(this.searchQ)
    },
    handleCurrentChange (current) {
      this.getList(current)
    },
    getList (num) {
      this.tableLoading = true
      api.ssOne2({
        content: this.content === '' ? undefined : this.content,
        type: 2,
        pages: 10,
        userId: this.userId,
        pageNo: num
      }).then(res => {
        this.tableLoading = false
        if (res && res.code === 200) {
          this.tableData = res.data.list2
          this.total = res.data.list1
        }
      })
    },
    handleCurrentChangeO (current) {
      this.getListO(current)
    },
    getListO (num) {
      this.tableLoadingR = true
      api.ssOne2({
        content: this.content === '' ? undefined : this.content,
        type: 1,
        pages: 10,
        userId: this.userId,
        pageNo: num
      }).then(res => {
        this.tableLoadingO = false
        if (res && res.code === 200) {
          this.tableDataO = res.data.list2
          this.totalO = res.data.list1
          // this.tableData = res.data.list2
          // this.total = res.data.list3
        }
      })
    },
    getList5 (num) {
      this.tableLoadingR = true
      api.ssOne2({
        content: this.content === '' ? undefined : this.content,
        type: 3,
        pages: 10,
        userId: this.userId,
        pageNo: num
      }).then(res => {
        this.tableLoading5 = false
        if (res && res.code === 200) {
          this.tableData5 = res.data.list2
          this.total5 = res.data.list1
          // this.tableData = res.data.list2
          // this.total = res.data.list3
        }
      })
    },
    handleCurrentChange5 (current) {
      this.getList5(current)
    },
    openIt (item) {
      api.subscription({
        phone: sessionStorage.getItem('qs_phone') || '',
        fileId: item.id,
        type: item.type
      }).then(resA => {
        // this.readable = resA.data.readable
        this.readMessage = resA.data.readMessage
        // this.type5 = resA.data.type
        if (resA.data.readable === 0) {
          this.itemElse = item
          this.showGetInfo = true
        } else {
          this.doGoRead(item)
        }
      })
    },
    doGoRead (item) {
      this.showGetInfo = false
      api.countDownload({
        fileId: item.id,
        type: item.type
      }).then(res => {
        if (res.code === 200) {
          // this.$message({
          //   message: '文件已下载至小智缓存目录',
          //   type: 'success'
          // })
          window.open(res.data.url)
        }
      })
    },
    openItO (item) {
      api.countDownload({
        fileId: item.id,
        type: item.type
      }).then(res => {
        if (res.code === 200) {
          // this.$message({
          //   message: '文件已下载至小智缓存目录',
          //   type: 'success'
          // })
          window.open(res.data.url)
        }
      })
    }
  },
  watch: {
    content () {
      this.getList(1)
      this.getListO(1)
      this.getList5(1)
    }
  },
  components: {
    accountCom,
    // banner,
    splitNewFiles,
    fileRank,
    // pcTitle
    PcTitleLogOnly
  }
}
</script>

<style lang="scss">
.h5public-personal {
  padding-bottom: 58px;
  position: relative;
  .dingyue {
    .file-list-per {
      .line {
        display: flex;
        margin-bottom: 5px;
        justify-content: space-between;
        align-items: center;
        padding: 2px 12px;
        &:nth-of-type(2n - 1) {
          background: #f4f5f6;
        }
        .left {
          flex: 0.9;
        }
        .right {
          color: #409eff;
          text-align: right;
          padding: 10;
          border: 0;
          flex: 0.1;
          cursor: pointer;
        }
        .status1 {
          color: #E6A23C;
        }
        .status2 {
          color: #67C23A;
        }
        .status3 {
          color: #F56C6C;
        }
      }
    }
  }
  .index-bottom-1 {
    position: fixed;
    left: 115%;
    top: 85%;
    width: 2810px;
    margin-left: -155%;
    background: #f2f6fc;
    text-align: left;
    font-size: 14px;
    padding: 10px;
    margin-top: 12px;
    .title-link {
      padding: 0 24px;
      padding-bottom: 8px;
      width: 700px;
      margin: 0 auto;
      font-size: 13px;
      .link-line {
        width: 1200px;
        .link-title {
          font-size: 16px;
          // color: #83889a;
          color: #000;
        }
        a {
          font-size: 14px;
          margin-right: 8px;
          color: #409EFF;
        }
      }
      .link-line-1 {
        width: 1200px;
        padding: 10px 0;
        a {
          font-size: 14px;
          margin-right: 8px;
          color: #551A8B;
        }
      }
    }
  }
  .public-back {
    transform: translateY(100%);
    text-decoration: underline;
    padding: 4px 12px;
    cursor: pointer;
    // position: fixed;
    top: 0;
    &:hover {
      color: #409EFF;
    }
    i {
      font-weight: bold;
    }
  }
  // .search-main {
  //   transform: translateY(10%);
  //   padding: 0 12px 12px;
  //   margin-top: -12px;
  //   .search-list {
  //     margin-top: -54px;
  //     // margin: 0!important;
  //     padding: 0!important;
  //     .file-filter{
  //       padding: 0;
  //     }
  //   }
  // }
  .doc-comment {
    background: #f4f5f6;
    .comment-title {
      padding: 2px 12px;
      display: flex;
      justify-content: space-between;
      .comment-more {
        color: #409EFF;
      }
    }
    .new-comment {
      border-bottom: 1px solid #efefef;
      padding: 2px 12px;
      color: #333;
      .comment-main {
        flex: 1;
        display: flex;
        .avator {
          width: 28px;
          height: 28px;
          border-radius: 100px;
          border: 1px solid #efefef;
          margin-right: 12px;
          flex: 0 0 28px;
        }
        .main-right {
          display: flex;
          flex-direction: column;
          .line {
            display: flex;
            align-items: center;
            .name {
              font-size: 14px;
              margin-right: 4px;
            }
            .time {
              color: #83889a;
            }
            .uni-icon {
              color: #28354c;
              margin-left: 8px;
              font-weight: 500;
            }
          }
          .content {
            .reply {
              padding: 0 8px;
              display: flex;
              flex-direction: column;
              .title {
                color: #83889a;
              }
            }
          }
        }
      }
    }
    .comment-empty {
      text-align: center;
      color: rgb(119, 119, 119);
    }
  }
  .bottom-wrap {
    position: fixed;
    bottom: 6px;
    left: 50%;
    width: 7.3rem;
    transform: translate(-50%);
    .bottom-main {
      display: flex;
      background: #fff;
      align-items: center;
      width: 7.3rem;
      margin: 0 auto;
      padding: 8px 12px;
      border-radius: 8px;
      box-shadow: 0px 2px 4px #ccc;
      .share {
        display: flex;
        flex-direction: column;
        margin-right: 12px;
        .text {
          line-height: 1;
          margin-top: 2px;
          font-size: 12px;
        }
      }
      .comment-input {
        // padding: 8px 0;
        height: 36px;
        line-height: 36px;
        flex: 1 0 25%;
        position: relative;
        .input-comment {
          input {
            height: 44px;
          }
        }
        img {
          position: absolute;
          right: 4px;
          top: 50%;
          transform: translateY(-50%);
          width: 28px;
        }
      }
      .big-button {
        flex: 0 0 80px;
        margin-left: 24px;
        display: flex;
        border-radius: 4px;
        overflow: hidden;
        cursor: pointer;
        .rules, .apply {
          flex: 1;
          text-align: center;
          line-height: 36px;
          height: 36px;
          color: #fff;
          &.gray {
            color: #fff;
            background: #666;
          }
        }
        .rules {
          background: linear-gradient(70deg,#eb934c,#d67946);
        }
        .apply {
          background: linear-gradient(70deg,#376dd6,#1b50b6);
        }
      }
      .cancel {
        margin-left: 12px;
      }
    }
  }
  .editor-wrap {
    // height: 520px;
    // padding: 12px;
    margin: 12px 12px 100px 12px;
    a {
      padding: 0 4px;
      img {
        width:18px;
        height:18px;
        vertical-align: text-bottom;
      }
    }
  }
  .home-banner {
    position: absolute;
    left: calc((100vw - 7.5rem) / 2 - 10px);
    top: 152px;
    transform: translateX(-100%);
    width: 300px;
    height: 56px; // 120
    position: fixed;
  }
  .searchdiv {
    position: absolute;
    left: calc((100vw - 7.5rem) / 2 - 10px);
    top: 2px;
    transform: translateX(-100%);
    width: 300px;
    height: 56px; // 120
    position: fixed;
    .search-tips{
      margin-top: -10px;
    }
  }
  .home-split-newfiles {
    position: fixed;
    left: calc((100vw - 7.5rem) / 2 - 10px);
    top: 16px;
    transform: translateX(-100%);
    width: 300px;
    height: 287px;
  }
  .file-rank-com {
    position: fixed;
    left: calc((100vw - 7.5rem) / 2 + 7.5rem + 10px);
    top: 16px;
    width: 300px;
    height: 287px;
    // height: 200px;
  }
  .w-e-text ul {
    list-style-type: disc;
  }
  .w-e-text ol {
    list-style-type: decimal;
  }
  .w-e-toolbar,
  .w-e-text-container,
  .w-e-menu-panel {
      padding: 0;
      margin: 0;
      box-sizing: border-box;
      background-color: #fff;
      /*表情菜单样式*/
      .eleImg{
          cursor: pointer;
          display: inline-block;
          font-size: 18px;
          padding: 0 3px;
      }
      * {
          padding: 0;
          margin: 0;
          box-sizing: border-box;
      }
      /*分割线样式*/
      hr{
        cursor: pointer;
        display: block;
        height: 0px;
        border: 0;
        border-top: 3px solid #ccc;
        margin: 20px 0;
      }
  }

  .w-e-clear-fix:after {
      content: "";
      display: table;
      clear: both;
  }

  .w-e-drop-list-item {
      position: relative;
      top: 1px;
      padding-right: 7px;
      color: #333 !important;
  }

  .w-e-drop-list-tl {
      padding-left: 10px;
      text-align: left;
  }

  .w-e-text-container {
      position: relative;

      .w-e-progress {
          position: absolute;
          background-color: #1e88e5;
          top: 0;
          left: 0;
          height: 1px;
      }

      .placeholder {
          color: #D4D4D4;
          position: absolute;
          font-size: 11pt;
          line-height: 22px;
          left: 10px;
          top: 10px;
          user-select: none;
          z-index: -1;
      }
  }
  .w-e-text {
      padding: 0 10px;
      overflow-y: auto;

      p,h1,h2,h3,h4,h5,table,pre {
          margin: 10px 0;
          line-height: 1.5;
      }

      ul, ol {
          margin: 10px 0 10px 20px;
      }

      blockquote {
          display: block;
          border-left: 8px solid #d0e5f2;
          padding: 5px 10px;
          margin: 10px 0;
          line-height: 1.4;
          font-size: 100%;
          background-color: #f1f1f1;
      }

      code {
          display: inline-block;
          background-color: #f1f1f1;
          border-radius: 3px;
          padding: 3px 5px;
          margin: 0 3px;
      }

      pre {

          code {
              display: block;
          }
      }

      table {
          border-top: 1px solid #ccc;
          border-left: 1px solid #ccc;

          td,th {
              border-bottom: 1px solid #ccc;
              border-right: 1px solid #ccc;
              padding: 3px 5px;
              min-height: 30px;
          }

          th {
              border-bottom: 2px solid #ccc;
              text-align: center;
              background-color: #f1f1f1;
          }
      }

      &:focus {
          outline: none;
      }

      img {
          cursor: pointer;

          &:hover {
              box-shadow: 0 0 5px #333;
          }
      }
  }

  .w-e-tooltip {
      position: absolute;
      display: flex;
      color: #f1f1f1;
      background-color: rgba(0,0,0,.75);
      box-shadow: 0 2px 8px 0 rgba(0,0,0,.15);
      border-radius: 4px;
      padding: 4px 5px 6px;
      position: absolute;
  }
  // 下箭头
  .w-e-tooltip-up::after {
      content: "";
      position: absolute;
      top: 100%;
      left: 50%;
      margin-left: -5px;
      border: 5px solid rgba(0,0,0,0);
      border-top-color: rgba(0,0,0,.73);
  }
  // 上箭头
  .w-e-tooltip-down::after {
      content: "";
      position: absolute;
      bottom: 100%;
      left: 50%;
      margin-left: -5px;
      border: 5px solid rgba(0,0,0,0);
      border-bottom-color: rgba(0,0,0,.73);
  }
  .w-e-tooltip-item-wrapper {
      cursor: pointer;
      font-size: 14px;
      margin: 0 5px;

      &:hover {
          color: #ccc;
          text-decoration: underline;
      }
  }
}
.nut-dialog {
  // max-width: 520px;
  max-width: 500px;
  position: relative;
  .nut-textinput {
    margin-top: 20px;
    padding: 0 20px;
  }
  .nut-textinput-label {
    text-align: left;
    width: 58px;
  }
  .register {
    margin-top: 8px;
    text-align: right;
    padding: 0 20px;
  }
  .register-tips {
    margin: 8px 20px -4px;
    text-align: left;
    color: #409EFF;
  }
  .action {
    margin-top: 20px;
    .login {
      display: block;
      margin: 0 auto;
      width: 120px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: #409EFF;
      color: #fff;
      border-radius: 4px;
      cursor: pointer;
    }
  }
  .icon-close {
    position: absolute;
    right: 20px;
    top: 20px;
    cursor: pointer;
  }
}
</style>
